import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import { useMenuHandlerDesktop } from '../../../../hooks/menu/useMenuHandlerDesktop';
import { AccordionMenuComponent } from '../components/AccordionMenuComponent';
import { MenuItemComponent } from '../components/MenuItemComponent';
import { DrawerHeaderComponent } from './DrawerHeaderComponent';
import { DrawerLogo } from './DrawerLogo';
import { LayoutMenuMobile } from './LayoutMenuMobile';
import {
  BoxChildren,
  BoxContainer,
  Drawer,
  IconDashboard,
  IconTransactions,
  StackAcountItem,
  StackUserDrawer,
  IconAccount,
} from './StyledComponentsMenu';
import { AcountItemDesktop } from './AcountItemDesktop';

export const LayoutMenu = ({ children }) => {
  const {
    menuItems,
    open,
    expanded,
    anchorEl,
    setAnchorEl,
    activeItem,
    setActiveItem,
    openMenu,
    user,
    navigate,
    location,
    querys,
    userNotOB,
    handleClick,
    handleClose,
    handleDrawerOpen,
    handleDrawerClose,
    handleAccordionChange,
    handleClickHome,
    handleNavigateDashboard,
    handleNavigateTransactions,
    handleNavigate,
    handleNavigateWallet,
    handleNavigateAccount,
  } = useMenuHandlerDesktop();

  if (
    location.pathname === '/' ||
    location.pathname === '/signin' ||
    location.pathname === '/signup' ||
    location.pathname === '/forgotpassword' ||
    location.pathname === '/forgotchangepassword' ||
    location.pathname === '/signupcreatepassword' ||
    location.pathname === '/signupconfirm' ||
    location.pathname === '/changeforgetpasswordsuccess' ||
    location.pathname === '/forgotpasswordconfirm' ||
    location.pathname === '/confirmAccountSuccess' ||
    /^.*\/signup\/[\w=]+$/.test(location.pathname) ||
    /^.*\/signupcreatepassword\/[\w=]+$/.test(location.pathname)
  ) {
    return <>{children}</>;
  }

  return (
    <>
      {!querys ? (
        <BoxContainer>
          <CssBaseline />

          <Drawer variant='permanent' open={open}>
            <DrawerHeaderComponent
              open={open}
              handleDrawerClose={handleDrawerClose}
              handleDrawerOpen={handleDrawerOpen}
            />
            <DrawerLogo
              open={open}
              handleClickHome={handleClickHome}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
            />

            <List sx={{ marginTop: open ? '21px' : '0px' }}>
              <MenuItemComponent
                open={open}
                icon={IconDashboard}
                label='Inicio'
                handleNavigate={handleNavigateDashboard}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
              />
              <MenuItemComponent
                open={open}
                icon={IconTransactions}
                label='Transacciones'
                handleNavigate={handleNavigateTransactions}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
              />

              <AccordionMenuComponent
                open={open}
                menuItems={menuItems}
                expanded={expanded}
                handleAccordionChange={handleAccordionChange}
                handleNavigate={handleNavigate}
                handleClick={handleClick}
                handleClose={handleClose}
                openMenu={openMenu}
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                navigate={navigate}
                handleNavigateWallet={handleNavigateWallet}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
              />
            </List>

            <StackAcountItem>
              <StackUserDrawer open={open}>
                <AcountItemDesktop user={user} open={open} userNotOB={userNotOB} />
              </StackUserDrawer>
            </StackAcountItem>
          </Drawer>

          <BoxChildren width={`calc(100% - ${open ? '240px' : '80px'})`} minHeight='100vh'>
            {children}
          </BoxChildren>
        </BoxContainer>
      ) : (
        <LayoutMenuMobile>{children}</LayoutMenuMobile>
      )}
    </>
  );
};
